import { onFCP as FCP } from "web-vitals";
export default function onFCP(callback) {
  FCP(callback);
}